import { _ as x } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { _ as e } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.object.assign-7e79fd7b.js";
import { c as H } from "./index-8b07dec9.js";
import { styled as n } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as y } from "./getMetrics-953aa4f8.js";
import { jsxs as W, jsx as s } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var w = ["title", "placeHolder", "height", "width", "className", "children"], a, h, u, P = n.div(a || (a = e([`
  display: `, `;
  padding: `, `;
  flex-direction: `, `;
  justify-content: `, `;
  align-items: `, `;
  border: `, `;
  background: `, `;
  height: `, `;
  box-sizing: `, `;
  width: `, `;
  box-sizing: `, `;
`])), function(t) {
  return t.theme.components.slot.SlotWrapper.display;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.padding;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.flexDirection;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.justifyContent;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.alignItems;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.border;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.background;
}, function(t) {
  var o = t.height;
  return o;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.boxSizing;
}, function(t) {
  var o = t.width;
  return o;
}, function(t) {
  return t.theme.components.slot.SlotWrapper.boxSizing;
}), T = n.span(h || (h = e([`
  color: `, `;
  text-align: `, `;
  font-family: `, `;
  font-size: `, `;
  font-style: `, `;
  font-weight: `, `;
  line-height: `, `;
`])), function(t) {
  return t.theme.components.slot.SlotTitle.color;
}, function(t) {
  return t.theme.components.slot.SlotTitle.textAlign;
}, function(t) {
  return t.theme.components.slot.SlotTitle.fontFamily;
}, function(t) {
  return t.theme.components.slot.SlotTitle.fontSize;
}, function(t) {
  return t.theme.components.slot.SlotTitle.fontStyle;
}, function(t) {
  return t.theme.components.slot.SlotTitle.fontWeight;
}, function(t) {
  return t.theme.components.slot.SlotTitle.lineHeight;
}), j = n.span(u || (u = e([`
  color: `, `;
  text-align: `, `;
  font-family: `, `;
  font-size: `, `;
  font-style: `, `;
  font-weight: `, `;
  line-height: `, `;
`])), function(t) {
  return t.theme.components.slot.SlotPlaceHolder.color;
}, function(t) {
  return t.theme.components.slot.SlotPlaceHolder.textAlign;
}, function(t) {
  return t.theme.components.slot.SlotPlaceHolder.fontFamily;
}, function(t) {
  return t.theme.components.slot.SlotPlaceHolder.fontSize;
}, function(t) {
  return t.theme.components.slot.SlotPlaceHolder.fontStyle;
}, function(t) {
  return t.theme.components.slot.SlotPlaceHolder.fontWeight;
}, function(t) {
  return t.theme.components.slot.SlotPlaceHolder.lineHeight;
}), mt = function(o) {
  var r = o.title, i = r === void 0 ? "Slot" : r, l = o.placeHolder, m = l === void 0 ? "This is a placeholder swap me" : l, p = o.height, f = p === void 0 ? "auto" : p, c = o.width, d = c === void 0 ? "auto" : c, S = o.className, g = o.children, v = x(o, w), b = y({
    label: "Slot"
  });
  return /* @__PURE__ */ W(P, Object.assign({
    height: f,
    width: d,
    className: H(["Slot", S])
  }, b, v, {
    children: [!!i && /* @__PURE__ */ s(T, {
      children: i
    }), !!m && /* @__PURE__ */ s(j, {
      children: m
    }), g]
  }));
};
export {
  mt as Slot
};
